import { ChartLine } from "lucide-react";
import {
  KpiChartParamsSchema,
  defaultChartParams,
  type KpiChartParams,
} from "@playbookai/widget-schemas";
import { registerWidget } from "../registry.js";
import type { SqlWidgetDef } from "../types.js";
import { KpiChartBody } from "../kpiChart/KpiChartBody.js";
import { KpiChartEditor } from "../kpiChart/KpiChartEditor.js";
import type { KpiChartView } from "../kpiChart/types.js";

/**
 * Chart — dashboard data widget. Same body + editor as `singleKpi`, but defaults
 * to a `line` chart and a wider footprint. `line`/`area`/`bar` render via recharts
 * (gated on reduced-motion); the number-centric types fall back to a static
 * sparkline. Shares the `KpiChartView` resolved view-model and `KpiChartParams`.
 */
export const chartDef: SqlWidgetDef<KpiChartParams, KpiChartView> = {
  kind: "chart",
  label: "Chart",
  modes: ["dashboard"],
  singleton: false,
  defaultSize: { w: 480, h: 320 },
  defaultParams: defaultChartParams,
  Component: KpiChartBody,
  storage: "sql",
  schema: KpiChartParamsSchema,
  accent: "purple",
  icon: ChartLine,
  subtitle: "KPI chart",
  defaultRoster: false,
  category: "multi",
  layout: { col: 1, row: 1, width: 480, height: 320 },
  dashboard: {
    icon: ChartLine,
    defaultWidth: "wide",
    category: "Operations",
    allowMultiple: true,
    supportsTitleOverride: true,
    EditorForm: KpiChartEditor,
  },
};

registerWidget(chartDef);
